import request from './request';

const orderService = {
  getAll: (params) =>
    request.get('dashboard/admin/orders/paginate', { params }),

  sendCodeForGiftCode : (parms) => request.post('dashboard/quickgift/giftcards-order/send-otp', parms),
  verifyCodeForGiftCode : (parms) => request.post('dashboard/quickgift/giftcards-order/verify-otp', parms),
  getById: (id, params) =>
    request.get(`dashboard/admin/orders/${id}`, { params }),
  create: (data) => request.post('dashboard/admin/orders', data),
  update: (id, data) => request.put(`dashboard/admin/orders/${id}`, data),
  calculate: (params) =>
    request.get('dashboard/admin/order/calculate/products', { params }),
  updateStatus: (id, params) =>
    request.post(`dashboard/admin/order/details/${id}/status`, {}, { params }),
  updateDelivery: (id, params) =>
    request.post(
      `dashboard/admin/order/details/${id}/deliveryman`,
      {},
      { params }
    ),
};

export default orderService;
